var _style, _path, _polygon, _g, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CED1D2;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#CED1D2;stroke:#262727;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#CED1D2;stroke:#313130;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{fill:#262727;}\n\t.st4{fill:#FFFFFF;stroke:#262727;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0971,6.084;}\n\t.st8{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:none;stroke:#262727;stroke-width:3.5104;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#262727;stroke-width:5.2656;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#262727;stroke-width:3.3321;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#262727;stroke-width:2;stroke-miterlimit:10;}\n\t.st15{fill:#FFFFFF;stroke:#262727;stroke-width:2.2376;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#262727;stroke-width:3.9275;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#262727;stroke-width:2.6183;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:none;}\n\t.st19{fill:none;stroke:#262727;stroke-width:2.6737;stroke-linecap:round;stroke-linejoin:round;}\n\t.st20{fill:none;stroke:#262727;stroke-width:2.6737;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0781,5.4695;}\n\t.st21{fill:none;stroke:#262727;stroke-width:1.7825;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st22{fill:#262727;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st24{fill:#FFFFFF;stroke:#262727;stroke-width:4.0567;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st25{fill:none;stroke:#262727;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:none;stroke:#262727;stroke-width:5.2656;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#262727;stroke-width:3.5848;stroke-linecap:round;stroke-linejoin:round;}\n\t.st28{fill:none;stroke:#262727;stroke-width:3.5848;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1048,7.3331;}\n\t.st29{fill:none;stroke:#262727;stroke-width:3.7276;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st30{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0616,6.2618;}\n\t.st31{fill:none;stroke:#262727;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.0775,5.8457;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.16,23.62H96.31c-10.36,0-18.77,9.39-18.77,20.97v194.27c0,11.58,8.41,20.98,18.77,20.98h90.86 c10.36,0,18.77-9.39,18.77-20.98V44.59C205.93,33.01,197.53,23.62,187.16,23.62z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "199.09,227.49 84.38,227.49 84.38,55.98 199.08,55.98 199.08,227.49 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "199.09,227.49 84.38,227.49 84.38,55.98 199.08,55.98 199.08,227.49  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.34,174.61c-2.67,0-4.84,2.17-4.84,4.84c0,2.67,2.17,4.84,4.84,4.84s4.84-2.17,4.84-4.84 C173.18,176.79,171.01,174.61,168.34,174.61"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "145.8,175.91 160.66,207.78 164.48,198.18 154.08,175.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "129.25,175.91 144.11,207.78 147.92,198.18 137.52,175.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "108.74,175.91 108.74,207.34 131.74,207.34 128.53,200.46 115.99,200.46 115.99,175.91  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 100.09,
    y1: 74.27,
    x2: 186.46,
    y2: 74.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 100.09,
    y1: 86.42,
    x2: 186.46,
    y2: 86.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 100.09,
    y1: 98.73,
    x2: 186.46,
    y2: 98.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 100.09,
    y1: 111.04,
    x2: 144.47,
    y2: 111.04
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.09,
    y: 131.91,
    className: "st3",
    width: 4.92,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110.23,
    y: 131.91,
    className: "st3",
    width: 4.92,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 142.74,
    y: 131.91,
    className: "st3",
    width: 4.92,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 181.54,
    y: 131.91,
    className: "st3",
    width: 4.92,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.33,
    y: 131.91,
    className: "st3",
    width: 4.92,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.88,
    y: 131.91,
    className: "st3",
    width: 4.92,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 131.91,
    className: "st3",
    width: 8.63,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.7,
    y: 131.91,
    className: "st3",
    width: 8.63,
    height: 26.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.21,
    y: 131.91,
    className: "st3",
    width: 8.63,
    height: 26.02
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129.81,40.55h23.85c0.79,0,1.43,0.64,1.43,1.43s-0.64,1.43-1.43,1.43h-23.85c-0.79,0-1.43-0.64-1.43-1.43 S129.02,40.55,129.81,40.55z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 141.73,
    cy: 243.67,
    r: 9.13
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.f4f8688bec244753a23b7d88ebd0c325.svg";
export { ForwardRef as ReactComponent };